import { Link, useLocation } from "react-router-dom";

const NavBar = ({ searchItm, setSearchItm }) => {
  const urlLocation = useLocation().pathname;

  const handleSearchChange = (e) => {
    setSearchItm(e.target.value);
  };

  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src="/images/logo.svg" alt="logo" />
        </Link>
        {urlLocation === "/" ? (
          <div className="flex-1 max-w-xs search-field group">
            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
            <input
              type="text"
              placeholder="Search Task"
              className="search-input"
              id="lws-searchTask"
              value={searchItm}
              onChange={handleSearchChange}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </nav>
  );
};

export default NavBar;
